module.exports = __webpack_public_path__ + "static/media/visa-bg.f485e208.png";